import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  PROJECT_CLUSTER_FEATURE_KEY,
  ProjectClusterState,
  ProjectClusterPartialState,
  projectClusterAdapter,
} from './project-cluster.reducer';
import { ProjectClusterDto } from '@cradua/data';

// Lookup the 'ProjectCluster' feature state managed by NgRx
export const getProjectClusterState = createFeatureSelector<
  ProjectClusterPartialState,
  ProjectClusterState
>(PROJECT_CLUSTER_FEATURE_KEY);

const { selectAll, selectEntities } = projectClusterAdapter.getSelectors();

export const getProjectClusterLoaded = createSelector(
  getProjectClusterState,
  (state: ProjectClusterState) => state.loaded
);

export const getProjectClusterError = createSelector(
  getProjectClusterState,
  (state: ProjectClusterState) => state.error
);

export const loadingProjectCluster = createSelector(
  getProjectClusterState,
  (state: ProjectClusterState) => state.loaded
);

export const getAllProjectCluster = createSelector(
  getProjectClusterState,
  (state: ProjectClusterState) => selectAll(state)
);

export const getProjectClusterEntities = createSelector(
  getProjectClusterState,
  (state: ProjectClusterState) => selectEntities(state)
);

export const getSelectedId = createSelector(
  getProjectClusterState,
  (state: ProjectClusterState) => state.selectedProjectClusterId
);

export const getSelected = createSelector(
  getProjectClusterEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId]
);

export const getSearchStudentRecord = createSelector(
  getAllProjectCluster,
  getSelectedId,
  (users: ProjectClusterDto[], selectedId) =>
    !selectedId
      ? null
      : users.filter(
          (user) =>
            user.id.toLowerCase().includes(String(selectedId).toLowerCase()) ||
            user.ClusterName.toLowerCase().includes(
              String(selectedId).toLowerCase()
            )
        )
);
